import { createVanIconComponent } from "./van"

const AppsOutlined = createVanIconComponent("apps-o")
export default AppsOutlined
